export const PASSWORD_RESET = "PASSWORD/RESET";
export const FORGOT_MPIN_REQUEST_OTP = "FORGOT/mpin_request_otp";
export const FORGOT_MPIN_VALIDATE_OTP = "FORGOT/mpin_validate_otp";
